export default __webpack_public_path__ + "static/SuisseIntl-Light-0316ca481bd9df5baa90ea53f20d136a.woff2";